import { useLocalizedMessages } from '../../../../i18n/index.js';
import { Button } from '../../../button/button.js';
import { IconButton } from '../../../button/icon-button.js';
import { useViewHeader } from './../use-view-header.js';
import { ViewGrid } from './../view-grid.js';
import { useDatePickerView } from './../view-provider.js';
import { useYearViewState } from './use-year-view-state.js';

/** @internal */
export function YearView() {
  const { switchToView } = useDatePickerView();
  const state = useYearViewState();
  const { prevButtonProps, nextButtonProps } = useViewHeader(state);
  const messages = useLocalizedMessages('datePicker');

  return (
    <>
      <div className="cim-date-picker-view-header">
        <IconButton slot={null} {...prevButtonProps} />

        <Button
          slot={null}
          aria-label={messages.format('switchToMultiYearView')}
          variant="tertiary"
          onPress={() => switchToView('multi-year')}
        >
          {state.header}
        </Button>

        <IconButton slot={null} {...nextButtonProps} />
      </div>

      <ViewGrid state={state} className="cim-date-picker-view-grid-year" />
    </>
  );
}
